module.exports = __webpack_public_path__ + "static/media/support.4ba8c831.svg";